/*
 * File: TaskCard.tsx
 * Project: a-a
 * File Created: Thursday, 14th November 2024 7:53:21 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 16th March 2026 10:19:15 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { memo, useEffect, useState } from 'react';
import CustomCard from '../../../../CustomCard/CustomCard';
import zeplinColor from '../../../../../../theme/Color';
import { Box, Button, Chip, Popover, Skeleton, Typography, useTheme } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Divider from '@mui/material/Divider';
import { Constants } from '../../../../../../utilities/constants';
import CustomPopOver from '../../../../CustomPopOver/CustomPopOver';
import { LightTooltip } from '../../../../CustomTooltip/CustomTooltip';
import CustomAlert from '../../../../CustomAlert/CustomAlert';
import { Link } from 'react-router-dom';
import CustomButton from '../../../../CustomButton/CustomButton';
import { SFService } from '../../../../../../service/SF.service';
import CustomModal from '../../../../CustomModal/CustomModal';
// import {ReactComponent as TaskIcon} from '../../../../../../../src'
import { ReactComponent as CopyLinkIcon } from '../../../../../../assets/copy-link.svg';
import { ReactComponent as ViewIcon } from '../../../../../../assets/view.svg';
import DeleteIcon from '../../../../../../assets/delete-red.png';
import MarkAsDoneIcon from '../../../../../../assets/mark-as-read.png';
import { ReactComponent as VerticalDots } from '../../../../../../assets/vertical-dots.svg';
import styles from './TaskCard.module.css';
import { AnyNaptrRecord } from 'dns';
// import { nativeConnectionNotEstablished } from '@azure/msal-browser/dist/error/BrowserAuthErrorCodes';
// import CustomAlertContain from '../../../../CustomAlert/CustomAlertContain';
// import '@salesforce-ux/design-system/assets/styles/salesforce-lightning-design-system.min.css';

const TaskCard = memo(
  ({
    data,
    loading,
    options = false,
    getTask,
    setAlert,
    setValue,
  }: {
    data: any;

    loading: boolean;
    options?: boolean;
    getTask?: (next?: boolean, clear?: boolean) => Promise<void>;
    setAlert?: React.Dispatch<React.SetStateAction<string>>;
    setValue?: React.Dispatch<React.SetStateAction<number>> | undefined;
  }) => {
    const selected = sessionStorage.getItem('sf_edit_selected');
    const sf_redirect = sessionStorage.getItem('sf_redirect');
    const sf_token = sessionStorage.getItem('SFToken') || '';
    const sf_delete = sessionStorage.getItem('sf_delete') || '';
    const sf_edit = sessionStorage.getItem('sf_edit') || '';
    let parse_sf = {
      access_token: '',
      id: '',
      instance_url: '',
      issued_at: '',
      refresh_token: '',
      scope: '',
      signature: '',
      token_type: '',
    };
    if (sf_token) {
      parse_sf = JSON.parse(sf_token);
    }
    const [edit, setEdit] = useState(false);
    const [taskAnchorEl, setTaskAnchorEl] = React.useState<HTMLDivElement | null>(null);
    const openTask = Boolean(taskAnchorEl);
    const idTask = openTask ? 'simple-popover' : undefined;
    const [action, setAction] = useState('');

    const theme = useTheme();

    const [anchorEl, setAnchorEl] = React.useState<HTMLImageElement | null>(null);
    const [loadingAction, setLoadingAction] = useState(false);
    const [copy, setCopy] = useState('');
    const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const [openModal, setOpenModal] = React.useState(false);
    // console.log(data?.date && new Date(data?.date) < new Date());
    // const relatedTo = data?.relatedTo?.split(' ');
    const handleCopyLink = (val: any) => {
      navigator.clipboard.writeText(val);
      setCopy('Link Copied');
    };
    const handleClose = () => {
      setCopy('');
    };
    const handleDeleteClose = (e?: any) => {
      e?.stopPropagation();
      setOpenModal(false);
      setTaskAnchorEl(null);
      setAnchorEl(null);
      sessionStorage.removeItem('sf_delete');
      sessionStorage.removeItem('sf_edit');
      sessionStorage.removeItem('sf_edi');
    };

    const deleteTask = async (id: string) => {
      setLoadingAction(true);
      try {
        const res = await SFService.deleteTask(id);
        setOpenModal(false);
        // onClose(false)();
        sessionStorage.removeItem('sf_delete');
        sessionStorage.removeItem('sf_edit_selected');
        // setDrawerState(false);
        // setDeleted(true);
        // setMsg({ message: `Task '${selected?.subject}' deleted successfully`, type: 'Success' });

        handleDeleteClose();
        getTask && getTask();
        setAlert && setAlert('Deleted successfully');
      } catch (err: any) {
        // setMsg({ message: `Task cannot be deleted`, type: 'Error' });
        console.log(err);
        setAlert && setAlert(err?.response?.data?.error);
      } finally {
        setLoadingAction(false);
      }
    };
    const markAsDone = async () => {
      try {
        setLoadingAction(true);
        const res = await SFService.editTask(data?.id, {
          // access_token: parse_sf?.access_token,
          Subject: selected ? JSON.parse(selected)?.subject : data?.subject,
          OwnerId: selected ? JSON.parse(selected)?.assignTo?.Id : data?.assignTo?.Id,
          //  recordTypeName: taskTypeSelected,
          ActivityDate: selected ? JSON.parse(selected)?.date : data?.date,
          ...(((selected && JSON.parse(selected)?.comments) || data?.comments) && {
            Description: selected ? JSON.parse(selected)?.comments : data?.comments,
          }),
          // ...(selectedItems.related[0]?.Id && { whatId: selectedItems.related[0]?.Id }), // parse_sf?.access_token,
          // ...(selectedItems.related[0]?.Id && { WhatId: selectedItems.related[0]?.Id }),
          // notes: comment,

          Status: 'Done',
          Priority: Array.isArray(selected ? JSON.parse(selected)?.priority : data?.priority)
            ? selected
              ? JSON.parse(selected)?.priority[0]
              : data?.priority[0]
            : selected
              ? JSON.parse(selected)?.priority
              : data?.priority,
          // ...(selectedItems.name[0].Id && { WhoId: selectedItems.name[0].Id }),
          // // ...(selectedItems.nameType && { nameType: selectedItems.nameType[0] }),
          // ...(link && { GD_Link__c: link }),
          // ...((attachments?.added?.length || attachments?.removed?.length) && {
          //   attachments: attachments,
          // }),
          // noteContent: 'test note content',
          // noteTitle: 'test note title',
        });
        getTask && getTask();
        handleDeleteClose();
        sessionStorage.removeItem('sf_edit_selected');
        sessionStorage.removeItem('sf_redirect');
        setAlert && setAlert('Marked as done successfully.');
      } catch (err: any) {
        console.log(err);
        setAlert && setAlert(err?.response?.data?.error);
      } finally {
        setLoadingAction(false);
      }
    };
    const alertMessage = (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // backgroundColor: !error ? zeplinColor.Success : '',
            borderRadius: '60px',
            padding: '3px',
          }}
        >
          <img src='/assets/checkmark-green.png' width={24} height={24} />
        </div>
        <Typography variant='body2' style={{ color: zeplinColor.Neutral1 }}>
          {copy}
        </Typography>
      </div>
    );
    const handleTaskEditClick = (event: React.MouseEvent<HTMLDivElement>) => {
      if (sf_token === 'true') {
        setEdit(true);
        handleOpen();
        setAnchorEl(null);
        // console.lo
      } else {
        setTaskAnchorEl(event.currentTarget);
        setAction('edit');
      }
    };
    const handleDeleteClick = (event: React.MouseEvent<HTMLDivElement>) => {
      if (sf_token === 'true') {
        handleOpen();
      } else {
        setTaskAnchorEl(event.currentTarget);
        setAction('delete');
      }
    };
    useEffect(() => {
      if (
        sf_token === 'true' &&
        selected &&
        JSON.parse(selected || '')?.id === data?.id &&
        !openModal
      ) {
        if (sf_delete === 'true') {
          // console.log(sf_delete === 'true' && parse_sf.access_token && !openModal);
          handleOpen();
        } else if (sf_edit === 'true' && sf_redirect !== 'Task') {
          handleOpen();
        }
      }
    }, [sf_token, sf_delete]);
    const handleOpen = () => setOpenModal((prev) => !prev);
    return (
      <Box
        sx={{
          borderRadius: '14px',
          width: '100%',
          backgroundColor: zeplinColor.Neutral1,
          border: `1px solid ${zeplinColor.Neutral5}`,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          cursor: 'pointer',
          '&:hover': {
            // backgroundColor: zeplinColor.Neutral4,
            borderColor: zeplinColor.BasicBlack,
          },
        }}
        onClick={() => {
          if (setValue) {
            setValue(2);
            sessionStorage.setItem('openTask', data?.id);
            sessionStorage.setItem('currentTab', '2');
          }
        }}
      >
        <CustomAlert
          open={copy ? true : false}
          handleClose={handleClose}
          message={alertMessage}
          error={false}
        />
        {loading ? (
          <>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px',
                gap: 5,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  // alignItems: 'center',
                  justifyContent: 'flex-start',
                  gap: '12px',
                  flex: 1,
                }}
              >
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '100%',
                    // Optionally adjust other styles here
                  }}
                />
                {data?.relatedTo && (
                  <Box
                    sx={{
                      display: 'flex',

                      alignItems: 'center',

                      gap: '8px',
                    }}
                  >
                    <Skeleton variant='rounded' width={26} height={26} />
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                      }}
                    />
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    // Optionally adjust other styles here
                  }}
                />
                <Box sx={{ position: 'relative' }}></Box>
              </Box>
            </Box>
            <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '12px', gap: 5 }}>
              <Box sx={{ display: 'flex', gap: '4px', flex: 1 }}>
                {' '}
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                  }}
                />
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box
              className={styles['task-card-header']}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
              }}
            >
              <Box
                className={styles['task-card-header-left']}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',

                  justifyContent: 'flex-start',

                  flex: 1,
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <Typography variant='responsiveLabel2' color={zeplinColor.Neutral9}>
                    {data?.source || 'SALESFORCE'}
                  </Typography>
                  <LightTooltip
                    title={
                      <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                        {data?.subject}
                      </Typography>
                    }
                    placement='bottom-start'
                    style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                  >
                    <Typography
                      variant='responsiveBody3'
                      sx={{
                        display: 'block',
                        // whiteSpace: 'nowrap', // Uncomment this line
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                        // height: '20px',
                        lineHeight: '20px',
                        paddingRight: '24px',
                        boxSizing: 'border-box',
                        // Keep gradient effect but adjust to not interfere with ellipsis
                        position: 'relative',
                      }}
                    >
                      {data?.subject || 'No Subject'}
                    </Typography>
                  </LightTooltip>
                </Box>
                {data?.relatedTo && (
                  <Box
                    sx={{
                      display: 'flex',
                      //   flexDirection: 'column',
                      alignItems: 'center',
                      // justifyContent: 'space-between',
                      gap: '8px',
                    }}
                  >
                    {(data?.relatedToType || data?.nameType) && (
                      <Box
                        className={styles['task-card-icon']}
                        sx={{
                          borderRadius: '100px',
                          padding: '10px',

                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: data?.avatar ? zeplinColor.Neutral1 : zeplinColor.Brand1,
                        }}
                      >
                        {data?.avatar ? (
                          <img
                            src={`${data?.avatar}`}
                            alt={data?.relatedToType || data?.nameType}
                            className={
                              data?.relatedToType === 'deal' ? '' : styles['task-card-icon']
                            }
                            style={{ borderRadius: '100px', objectFit: 'cover' }}
                          />
                        ) : (
                          <img
                            src={`/assets/salesforce/${
                              data?.relatedToType
                                ? data?.relatedToType?.toLocaleLowerCase()
                                : data?.nameType?.toLocaleLowerCase()
                            }.${
                              data?.relatedToType?.toLocaleLowerCase() === 'deal' ? 'png' : 'svg'
                            }`}
                            alt={data?.relatedToType || data?.nameType}
                            className={
                              data?.relatedToType === 'deal' ? '' : styles['task-card-icon']
                            }
                          />
                        )}
                      </Box>
                    )}
                    <Typography variant='responsiveBody3'>
                      {data?.relatedTo?.Id
                        ? data?.relatedTo?.Name
                        : data?.name?.Id
                          ? data?.name?.Name
                          : 'N/A'}
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // flexDirection: 'column',
                  gap: '4px',
                }}
              >
                {data?.isOverdue && (
                  <img src={'/assets/overdue-icon.svg'} className={styles['overdue-icon']} />
                )}
                <Chip
                  label={
                    <Typography
                      variant='responsiveLabel1'
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      {data?.priority}
                    </Typography>
                  }
                  sx={{
                    bgcolor:
                      Constants.PriorityTask[
                        (data?.priority || 'Medium') as 'Normal' | 'Low' | 'High'
                      ],
                    color: zeplinColor.Neutral1,
                    // width: '39px',
                    '&.MuiChip-root': {
                      // height: '22px',
                      padding: '4px 8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: { xs: '18px', xl: '22px' }, // 18px below 1700px, 22px above
                      // padding: {  '4px 8px' }, // Smaller padding below 1700px
                      borderRadius: '50px',
                    },
                    '& .MuiChip-label': {
                      padding: 0,
                    },
                  }}
                />
                {options && (
                  <Box
                    sx={{
                      position: 'relative',
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {/* <Button aria-describedby={id} onClick={handleClick}> */}
                    {options && (
                      <LightTooltip
                        title={
                          <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                            Options
                          </Typography>
                        }
                        placement='bottom-end'
                        style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                        // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
                      >
                        {/* <MoreVertIcon onClick={handleClick} aria-hidden='false' /> */}
                        {/* <img
                        width={'18px'}
                        height={'18px'}
                        src={'/assets/vertical-dots.svg'}
                        alt='options-icon'
                        onClick={handleClick}
                        aria-hidden='false'
                        // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
                      /> */}
                        <VerticalDots
                          className={styles['vertical-icon']}
                          onClick={(e: any) => {
                            e.stopPropagation();
                            handleClick(e);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </LightTooltip>
                    )}
                    {/* </Button> */}
                    <CustomPopOver
                      onClick={(e: any) => {
                        e.stopPropagation();
                      }}
                      setAnchorEl={setAnchorEl}
                      anchorEl={anchorEl}
                      id={id}
                      sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '16px',
                          padding: '16px',
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCopyLink(data?.link);
                          }}
                        >
                          {/* <img src={'/assets/copy-link.svg'} width={18} height={18} /> */}
                          <CopyLinkIcon width={18} height={18} />
                          <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                            Copy Link
                          </Typography>
                        </Box>
                        <a
                          href={data?.link}
                          onClick={(e) => {
                            e.stopPropagation();
                            // handleCopyLink(data?.link);
                          }}
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ textDecoration: 'none' }}
                        >
                          <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                            {/* <img src={'/assets/view.svg'} width={18} height={18} /> */}
                            <ViewIcon width={18} height={18} />
                            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                              View in salesforce
                            </Typography>
                          </Box>
                        </a>
                        {data?.status !== 'Completed' && (
                          <Box
                            sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTaskEditClick(e);
                            }}
                          >
                            <img src={MarkAsDoneIcon} alt='done' width={18} height={18} />
                            {/* <MarkAsDoneIcon width={18} height={18} /> */}
                            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                              Mark as done
                            </Typography>
                          </Box>
                        )}
                        <Box
                          sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteClick(e);
                          }}
                        >
                          <img src={DeleteIcon} width={18} height={18} />
                          {/* <DeleteIcon width={18} height={18} /> */}
                          <Typography variant='responsiveBody3' color={zeplinColor.Error}>
                            Delete
                          </Typography>
                        </Box>
                      </Box>
                    </CustomPopOver>
                    <CustomPopOver
                      setAnchorEl={setTaskAnchorEl}
                      anchorEl={taskAnchorEl}
                      id={idTask}
                      sx={{
                        borderRadius: '14px',
                        boxShadow: 'rgba(0, 0, 0, 0.15)',
                        marginTop: '8px',
                        // marginRight: '2rem',
                        // marginLeft: '-4rem',
                      }}
                    >
                      <Box
                        sx={{
                          height: '202px',
                          width: '340px',
                          padding: '24px',
                          display: 'flex',
                          gap: '32px',
                          flexDirection: 'column',
                        }}
                      >
                        <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                          <Box
                            sx={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}
                          >
                            <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                              Authentication Required
                            </Typography>
                            <img
                              src={'/assets/close-icon.svg'}
                              width={24}
                              height={24}
                              alt='close'
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setTaskAnchorEl(null);
                              }}
                            />
                          </Box>

                          <Typography variant='body3' color={zeplinColor.BasicBlack}>
                            {/* To create a new task, please ensure you're logged in to your Salesforce
                            account. */}
                            You need to be logged into Salesforce to perform this action. Please log
                            in to your Salesforce account.
                          </Typography>
                        </Box>
                        <Link
                          // target='_blank'
                          // rel='noopener noreferrer'
                          to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
                        >
                          <CustomButton
                            disabled={false}
                            onClick={() => {
                              setOpenModal(false);
                              // setEdit(false);

                              sessionStorage.setItem('sf_redirect', 'Overview');
                              sessionStorage.setItem('sf_edit_selected', JSON.stringify(data));
                              action === 'edit'
                                ? sessionStorage.setItem('sf_edit', 'true')
                                : sessionStorage.setItem('sf_delete', 'true');
                            }}
                            variant='contained'
                            color={'primary'}
                            style={{
                              width: '155px',
                              borderRadius: '14px',
                              height: '48px',
                              padding: '14px 16px',
                              '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                            }}
                            textStyle={{ color: zeplinColor.Neutral1 }}
                            text={'Open Salesforce'}
                            // tabindex={4}
                          />
                        </Link>
                      </Box>
                    </CustomPopOver>
                  </Box>
                )}
              </Box>
            </Box>
            <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
            <Box
              className={styles.taskCardFooter}
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Box sx={{ display: 'flex', gap: '4px' }}>
                {' '}
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                  Assigned To:
                </Typography>
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  {data?.assignedTo?.Id ? data?.assignedTo?.Name : 'N/A'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img className={styles.calendarIcon} src='/assets/calendar.svg' style={{}} />
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  {data?.dueDate
                    ? new Date(data?.dueDate)
                        .toLocaleString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/(\s)(\w{3})(\s)(\d{4})/, '$1$2, $4')
                    : ''}
                </Typography>
              </Box>
            </Box>
          </>
        )}
        <CustomModal handleClose={handleDeleteClose} open={openModal}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CustomCard
              styles={{
                borderRadius: '14px',
                padding: '24px',
                backgroundColor: zeplinColor.Neutral1,

                width: '312px',
                height: '201px',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                  }}
                >
                  <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                    {sf_edit || edit ? 'Mark as done' : 'Delete Task?'}
                  </Typography>
                  <Typography variant='body2' color={zeplinColor.BasicBlack}>
                    {sf_edit || edit
                      ? 'Are you sure you want to mark this task as Done?'
                      : 'Are you sure you want to delete this task? This action cannot be undone.'}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',

                    gap: '16px',
                  }}
                >
                  <Box
                    onClick={handleDeleteClose}
                    sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                  >
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 32px',
                        backgroundColor: zeplinColor.Neutral1,
                        border: `1px solid ${zeplinColor.BasicBlack}`,
                        cursor: 'pointer',
                        // width: '312px',
                        // height: '183px',
                        display: 'flex',
                        justifyContent: 'center',
                        flex: 1,
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                      }}
                      aria-role='button'
                      aria-disable={loading}
                    >
                      <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                        Cancel
                      </Typography>
                    </CustomCard>
                  </Box>
                  <Box
                    onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                      e.stopPropagation();
                      sf_edit || edit
                        ? markAsDone()
                        : !selected
                          ? deleteTask(data?.id)
                          : deleteTask(JSON.parse(selected || '')?.id);
                    }}
                    sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                  >
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 32px',
                        backgroundColor: zeplinColor.Error,
                        cursor: 'pointer',
                        // border: `1px solid ${zeplinColor.BasicBlack}`,
                        // width: '312px',
                        // height: '183px',
                        display: 'flex',
                        justifyContent: 'center',
                        flex: 1,
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                      }}
                      aria-role='button'
                      aria-disable={loading}
                    >
                      <Typography
                        variant='buttonMedium'
                        color={zeplinColor.Neutral1}
                        sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                      >
                        {sf_edit || edit
                          ? loadingAction
                            ? 'Confirming'
                            : 'Confirm'
                          : loadingAction
                            ? 'Deleting'
                            : 'Delete'}
                      </Typography>
                    </CustomCard>
                  </Box>
                </Box>
              </Box>
            </CustomCard>
            {/* {loading ? <CustomLoader /> : ''} */}
          </Box>
        </CustomModal>
      </Box>
    );
  },
);

export default TaskCard;
